

const formProcessor = function (_form) {

  // Doing error handling on form submit won't work here because the validation blocks the submit event from firing.
  // https://codepen.io/davatron5000/pen/YErprg
  // Get all the inputs...
  const inputs = _form.querySelectorAll('input, select, textarea');

  // Loop through them...
  // for(let input of inputs) {
  inputs.forEach((input) => {

    // Just before submit, the invalid event will fire, let's apply our class there.
    input.addEventListener('invalid', (event) => {
      input.classList.add('b-form-error');
    }, false);

    // Optional: Check validity onblur
    input.addEventListener('blur', (event) => {
      let valid = input.checkValidity();
      if(valid) input.classList.remove('b-form-error');
    })

    if (input.getAttribute('type') == 'checkbox') {
      input.addEventListener('input', (event) => {
        let valid = input.checkValidity();
        if(valid) input.classList.remove('b-form-error');
      })
    }
  })

  _form.addEventListener("submit", function (event) {
    event.preventDefault();
    sendData(_form);
  });

  function sendData(_form) {

    // overlayShow()
      let btn = _form.querySelector('[type="submit"]')
      // console.log('sendData _form', _form);
      // console.log('sendData btn', btn);
      let body = document.querySelector('body')
      btn.classList.add('processing')

    let XHR = new XMLHttpRequest();

    // Bind the FormData object and the form element
    let FD = new FormData(_form);

    // Define what happens on successful data submission
    XHR.addEventListener("load", function(event) {
      // alert(event.target.responseText);

      // 3 Успешная отправка формы
      // ga("send", "event", "competition", "send success");

      // let res = document.querySelector('.b-form__wrapper')
      let res = _form.parent('.b-form__wrapper')
      setTimeout(() => {

        res.innerHTML = event.target.responseText
        // let __form = document.getElementById("_Form");
        let __form = res.querySelector('form')
        // console.log('XHR.addEventListener load __form', __form);
        if (__form) {
          callRecaptchaToken(__form)
          formProcessor(__form)
          // custom select reInit
          let isCustomSelect = __form.querySelector('.b-form__select-wrapper')
          if (isCustomSelect && !isMobile && typeof window.initCustomSelect == 'function') {
            window.initCustomSelect()
          }
        }

        // res.innerHTML = `
        //   <div class="injected tac">
        //     Спасибо, ваша заявка принята!
        //   </div>
        // `;
        // window.scrollTo(0, 1000)
        // overlayHide()
        btn.classList.remove('processing')
        body.classList.remove('grecaptcha-badge--show')
      }, 1000);
    });

    // Define what happens in case of error
    XHR.addEventListener("error", function(event) {
      alert('Oops! Something went wrong.');
    });

    // Set up our request
    XHR.open("POST", _form.getAttribute('action'));

    // The data sent is what the user provided in the form
    XHR.send(FD);
  }
}

export { formProcessor };